import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import CommonCrypt from "../Common/CommonCrypt";
import { StarIcon ,InstagramIcon, FacebookIcon, XIcon, YoutubIcon } from "../../components/svgIcon";
import { Container, Row, Col ,Image } from 'react-bootstrap';
import "./_sitemap.scss";

function SiteMap({ content, Constant }) {
    const APP_URL = window.site_url;
    const [SiteMapdata,setSiteMapdata] = useState([]);
    const [isOpen, setIsOpen] = useState(false); // State to track whether the accordion is open or closed
    const toggleAccordion = () => {
        setIsOpen(prevState => !prevState);
      };
    useEffect(()=>{
        const fetChData = async () =>{
            const response = await fetch(APP_URL + `/api/sitemap`,{
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                });
            const sitemap_data = await response.json();
            const sitemapDecrypted = JSON.parse(CommonCrypt(sitemap_data.sitemap_result));
            setSiteMapdata(sitemapDecrypted);
        };
        fetChData();
    },[]);

    const renderMenu = (menu) => {
        return (
            <li key={menu?.txtPageUrl} className="accordion-item">
                <div className="d-flex align-items-center justify-content-between">
                    <Link to={'/' + menu?.txtPageUrl} className="title" title={menu?.varTitle} target={menu?.chrNewTab === 'Y' ? '_blank' : '_self'} rel={menu?.chrNewTab === 'Y' ? 'noopener noreferrer' : undefined}>
                        {menu?.varTitle}
                    </Link>
                    {menu?.children && menu?.children?.length > 0 ? (
                        <span className="accordion-button collapsed" onClick={toggleAccordion} id={`flush-heading${menu?.id}`} data-bs-toggle="collapse" data-bs-target={`#flush-collapse${menu?.id}`} aria-expanded="false" aria-controls={`flush-collapse${menu?.id}`}></span>
                    ) : ''}
                </div>
                {menu?.children && menu?.children?.length > 0 && (
                    <ul id={`flush-collapse${menu?.id}`} className={`accordion-dropdown ${isOpen ? 'show' : ''}`} aria-labelledby={`flush-heading${menu?.id}`} data-bs-parent="#accordionFlushExample">
                        {menu?.children?.map((child) => renderSubMenu(child))}
                    </ul>
                )}
                <span className="star-pattern position-absolute z-1">
                    {["first", "second", "third"]?.map((name, index) => (
                        <i key={index} className={`star position-relative ${name}`}>
                            <StarIcon />
                        </i>
                    ))}
                </span>
            </li>
        );
    };
    const renderSubMenu = (child) => {
        return (
            <li key={child?.txtPageUrl}>
                <Link to={'/' + child?.txtPageUrl} className="title" title={child?.varTitle}>
                    {child?.varTitle}
                </Link>
                {child?.children && child?.children?.length > 0 && (
                    <ul>
                        {child?.children?.map((child) => renderSubMenu(child))}
                    </ul>
                )}
            </li>
        );
    };

    return (
        <>
            <section className="sitemap-page section-gap double-gap">
                <Container>
                    <Row>
                        <div className="col-12">
                            <div className="sitemap-list">
                                <ul className="content accordion accordion-flush" id="accordionFlushExample">
                                    <li><Link to={APP_URL} title="Home">Home</Link>
                                        <span className="star-pattern position-absolute z-2">
                                            {["first", "second", "third"]?.map((name, index) => (
                                                <i key={index} className={`star position-relative ${name}`}>
                                                    <StarIcon />
                                                </i>
                                            ))}
                                        </span>
                                    </li>
                                    {/* Dynamic Menu Items */}
                                    { SiteMapdata?.map((itemPerent) => renderMenu(itemPerent))}
                                    {/* Custom Menu Item */}
                                    <li>
                                        <Link to={APP_URL + '/sitemap.xml'} target="_blank" className="title flex-grow-1" title="XML Site Map">XML Site Map</Link>
                                        <span className="star-pattern position-absolute z-2">
                                            {["first", "second", "third"]?.map((name, index) => (
                                                <i key={index} className={`star position-relative ${name}`}>
                                                    <StarIcon />
                                                </i>
                                            ))}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </Row>
                </Container>
                <div className="device-social-share social-icon section-gap double-gap pb-md-0">
                    <Container>
                        <Row>
                            <Col lg={12}>
                            <h2 className="sec-heading text-center mb-4" data-aos="fade">
                                <span className="ff-2">
                                    <span className="star">
                                        <i className="blue" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="100"><StarIcon/></i>
                                        <i className="red" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="300"><StarIcon/></i>
                                        <i className="yellow" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="100"><StarIcon/></i>
                                    </span>
                                    <span data-aos="fade" data-aos-duration="1500" data-aos-delay="500">Follow Us</span>
                                </span>
                                <span className="title-line" data-aos="fade" data-aos-duration="1500" data-aos-delay="500">
                                    <span>Social Media</span>
                                </span>
                            </h2>
                            </Col>
                            <Col xs={12}>
                                <ul className="social-box list-unstyle d-flex flex-wrap my-4 p-0 justify-content-center text-center">
                                    {
                                        Constant?.SOCIAL_FB_LINK ? (<li data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="120">
                                            <i className="facebook"><Link to={Constant?.SOCIAL_FB_LINK} title="Follow Us On Facebook" target="_blank" className="f-icon hvr-bdr"><FacebookIcon /></Link></i>
                                        </li>) : ''
                                    }
                                    {
                                        Constant?.SOCIAL_TWITTER_LINK ? (<li data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="120">
                                            <i className="twitter"><Link to={Constant?.SOCIAL_TWITTER_LINK} title="Follow Us On X" target="_blank" className="f-icon hvr-bdr"><XIcon /></Link></i>
                                        </li>) : ''
                                    }
                                    {
                                        Constant?.SOCIAL_YOUTUBE_LINK ? (<li data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="120">
                                            <i className="youtub"><Link to={Constant?.SOCIAL_YOUTUBE_LINK} title="Follow Us On YouTube" target="_blank" className="f-icon hvr-bdr"><YoutubIcon /></Link></i>
                                        </li>) : ''
                                    }
                                    {
                                        Constant?.SOCIAL_INSTAGRAM_LINK ? (<li data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="120">
                                            <i className="instagram"><Link to={Constant?.SOCIAL_INSTAGRAM_LINK} title="Follow Us On Instagram" target="_blank" className="f-icon hvr-bdr"><InstagramIcon /></Link></i>
                                        </li>) : ''
                                    }
                                </ul>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
        </>
    );
}

export default SiteMap;
